import { useEffect, useState } from "react";
import { _BudgetRPFactory, _BudgetSheetFactory, _single } from "../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { toast } from "react-toastify";
import { BasicTable } from "../../theme/Component/BasicTable";
import { ListMenu } from "../../theme/Component/ListMenu";
import { Modal } from "../../theme/Component/Modal";
import { MASK_MONEY } from "../../theme/Component/BasicTable2";
import { _BudgetCDPreductionFactory } from "../../../core/services/dataBean/EntityCatalogVdos";
import { InputMoney } from "../../theme/Input/InputMoney";

interface Props {
    sheetForm: any;
    onChange: Function;
}

export const FormBudgetCDPreductionAgregar = ({ sheetForm, onChange }: Props) => {

    const { bean, setBean, lista, setLista, instance } = useDataBean(_BudgetCDPreductionFactory);
    const [initBean, setInitBean] = useState<any>({});
    const [missingFields, setMissingFields] = useState<string[]>([]);
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [listatable, setListatable] = useState<any>([]);
    const _budgetRDFactory = useDataBean(_BudgetRPFactory);


    useEffect(() => {
        getBudgetByDoc();
    }, [modal])


    const head = [
        { title: 'Rubro Presupuestal', property: 'BudgetName', visible: true },
        { title: 'Certificado de disponibilidad Presupuestal', property: 'CDPDocument', visible: true },
        { title: 'Vr Certificado de Disponibilidad', property: 'CDPValue', visible: true , mask: MASK_MONEY},
        { title: 'Vr CDP por Comprometer', property: 'LeftValue', visible: true, mask: MASK_MONEY },
        { title: 'Valor a Reducir', property: 'Value', visible: true, mask: MASK_MONEY },
        { title: 'Recurso Presupuestal', property: 'BudgetResourceName', visible: true },
        { title: 'Observaciones', property: 'Description', visible: true },
    ]

    const headtwo = [
        { title: 'Rubro Presupuestal', property: 'BudgetIDName', visible: true },
        { title: 'Recurso Presupuestal', property: 'BudgetResourceName', visible: true },
        { title: 'Fuente de Fiannciamiento', property: 'BudgetSourceName', visible: true },
        { title: 'Valor CDP', property: 'Value', visible: true },
        { title: 'Valor Compometido', property: 'RPValue', visible: true },
    ]

    const getBudgetByDoc = () => {
        _budgetRDFactory.instance.getCDPBudgetByDocument(sheetForm.IDDocument, sheetForm.DocumentDate).then(
            (resp) => {

                setListatable(resp)
            }
        ).catch(
            err => {
                console.log(err)
            }
        )
    }


    const listaBotones = () => {
        const botones = [
            // { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { setModal({ ...modal, "view": true, "name": "Editar" }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { eliminarItem() } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const createItem = () => {
        setBean({});
        setModal({ ...modal, "view": true, "name": "Crear" })
    }

    const eliminarItem = () => {
        if (!bean || !bean.Value) {
            toast.error("No se ha seleccionado un ítem para eliminar.");
            return;
        }

        const updatedLista = lista.filter((item: any) => item.DataBeanProperties.Value !== bean.Value);

        setLista(updatedLista);
        setBean({});
    };

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: createItem }
    ]

    const createNewItem = () => {

        const updatedLista = lista.filter((item: any) =>
            JSON.stringify(item.DataBeanProperties) !== JSON.stringify(initBean)
        );

        instance.createBudgetRowForCDPReduction(bean.BudgetIDStr, bean.IDDocument, bean.DocumentDate, bean.IDBudgetResource, bean.IDBudgetSource, bean.IDAdquisitionItem, bean.Description, bean.Value).then(
            (resp) => {
                let temp = [...updatedLista, {
                    DataBeanProperties: resp,
                    DataBeanName: 'budget.Budget'
                }];
                setLista(temp);
                setBean({});
                setModal({ ...modal, "view": false })
            }
        ).catch(
            err => {
                toast.error(err);
            }
        )
    }

    const setRowBean = (object: any) => {
        setBean(object);
        setInitBean(object)
    }

    const validateData = () => {

        createNewItem();

    }

    const validateForm = () => {
        const requiredFields = [
            "Value", "BudgetIDStr"
        ];

        let missing = [];
        for (let field of requiredFields) {
            if (bean[field] === null || bean[field] === undefined || bean[field] === "") {
                missing.push(field);
            }
        }
        setMissingFields(missing);
        return missing.length
    };

    useEffect(() => {
        onChange(lista);
    }, [lista])

    return (
        <div className="row">
            <BasicTable body={lista} head={head} rowSet={(e) => { setRowBean(e) }} listButtons={listaBotones()} iconButtons={iconButtonsItem} />

            <div className="col-md-12">
                <Modal modal={modal} updateModal={setModal} eventModal={validateData} >
                    <label><strong />Selecciona una Fila</label>
                    <BasicTable body={listatable} head={headtwo} rowSet={(e) => { setRowBean(e) }} />
                    <div className="row">
                        <div className="col-md-12">
                            <label>Valor a Reducir</label>
                            <InputMoney _label=" " _value={bean.Value} onChange={(e) => { setBean({ ...bean, "Value": e }) }} />
                        </div>
                        <div className="col-md-12">
                            <label>Descripción</label>
                            <textarea className="form-control" value={bean.Description} onChange={(e) => { setBean({ ...bean, "Description": e.target.value }) }} />
                        </div>
                    </div>
                </Modal>
            </div>
        </div>
    )
}